<template>
  <b-offcanvas :visible="showChat" @close="modelValue = false" :width="anchoSidebar"
    header-class="bg-primary d-flex justify-content-between align-items-center" footer-class="p-1" 
    body-class="p-0 d-flex align-items-center"
    @show="scrollear">

    <template #header="{hide}">
      <b-button-group size="sm">
        <b-button @click="cerrarChat()" variant="dark" class="d-flex align-items-center" v-if="$can('read','Chat')">
          <font-awesome-icon icon="fas fa-plus" />
          Nuevo Chat
        </b-button>
      </b-button-group>

      <b-button-group size="sm">
        <b-button @click="hide()" variant="dark">
          <font-awesome-icon icon="fas fa-times" />
        </b-button>
      </b-button-group>

    </template>

    <ChatPanel :actions="actionsChat" class="h-100 " />


    <template #footer>
      <b-form
        @submit.prevent="enviarMensaje"
        v-if="$can('read', 'Chat')"
        v-show="aperturado"
      >
        <b-input-group>
          <b-form-input type="search" class="input-form" autofocus v-model="mensaje"
            placeholder="¿Que quieres saber? Pregunta lo que quieras." :readonly="loading || esperandoRespuesta"
            :disabled="esperandoRespuesta" v-bind="mensaje_attrs" :state="!errors.mensaje" />
          <b-button type="submit" variant="primary" :disabled="loading">
            <font-awesome-icon icon="fas fa-paper-plane" />
          </b-button>
        </b-input-group>
      </b-form>
    </template>
  </b-offcanvas>
</template>

<script setup>
  import ChatPanel from 'components/ChatPanel.vue';
  import useChatbot from '@composables/useChatbot';
  import {
    useForm
  } from 'vee-validate';

  const prop = defineProps({
    showChat:Boolean
  })

  import useAppStore from '@/store/app';
  import { storeToRefs } from 'pinia';
  import useRootStore from '@/store/root';
  import useUsuarioStore from '@/store/usuario';
  import { required } from '@validations';

  const usuario_store = useUsuarioStore();
  const root_store = useRootStore();

  const { usuario } = storeToRefs(usuario_store);
  const { loading } = storeToRefs(root_store);


  const model = defineModel('showChat',{type:Boolean});

  const app_store = useAppStore();
  const { anchoSidebar } = storeToRefs(app_store);

  const actionsChat = useChatbot();

  const {
    formulario,
    mensajes,
    formValidate,
    showChatbot,
    aperturado,
    refChatLogPS,
    // methods
    enviar,
    cerrar,
    abrirChat,
    aperturarChat,
    scrollToBottomInChatLog,
    cerrarChat,
    esperandoRespuesta,
    chatAbierto
  }  = actionsChat;

const { defineField, errors, handleSubmit, resetForm } = useForm({
  initialValues: formulario,
  validationSchema: {
    mensaje: required
  }
});

const [mensaje, mensaje_attrs] = defineField('mensaje');


const enviarMensaje = handleSubmit((values) => {
  enviar(values, scrollToBottomInChatLog)
  resetForm();
});





const scrollear = () => {
  chatAbierto()
  setTimeout(() => {
    scrollToBottomInChatLog();
  }, 500);
}


</script>
